import React, {useEffect, useState} from "react";
import { ProfileCard } from "./components/ProfileCard";
import CircularProgress from '@mui/material/CircularProgress';
import { Box, Typography } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { Applicant } from 'types';
import { getApplicantsByUid, getReferrer } from 'apis';
enum Status {
  Loading,
  Error,
  Success,
}
const LoadingIndicator: React.FC = () => {
  return (
    <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
      <CircularProgress />
    </Box>
  );
};

export const ProfilePage = () => {
  const { uid } = useParams<{ uid: string }>();
  const [applicant, setApplicant] = useState<Applicant | undefined>(undefined);
  const [status, setStatus] = useState<Status>(Status.Loading);
  const [isReferrerActive, setIsReferrerActive] = useState(false);
  const navigate = useNavigate();
  const [companyName, setCompanyName] = useState<string | null>(null);
  useEffect(() => {
    const fetchData = async function (uid: string) {
      const applicantSnapShot = await getApplicantsByUid(uid);
      if (applicantSnapShot.exists()) {
        setApplicant(applicantSnapShot.data());
        const referrerSnapshot = await getReferrer(uid);
        if (referrerSnapshot.exists()) {
          const referrerData = referrerSnapshot.data();
          setIsReferrerActive(referrerData.isActivated ?? false);
          if (referrerData !== undefined) {
            setCompanyName(referrerData.company);
          }
        }
        setStatus(Status.Success);
      }
      else {
        setStatus(Status.Error);
      }
    };
    fetchData(uid?? '');
  }, [uid]);

  const handleReferralInfo = (id:string) => {
    if (isReferrerActive) {
      navigate(`/companies/${encodeURIComponent(companyName!)}/referrers/${id}/apply`);
    }
  };
  return (
    status === Status.Loading ? <LoadingIndicator /> :
    status === Status.Error ?
    <Box display="flex" flexDirection="column"  alignItems="center" height="100vh" width='100%' padding={'256px 16px 0px 16px'} >
      <Typography variant="h1" sx={{fontSize:'64px'}} > 404 </Typography>
      <Typography variant="h1" sx={{color:'secondary.main'}} gutterBottom> Oops! </Typography>
      <Typography variant="h3"> Profile not found! Please check the UserId after profile/ is correct!</Typography>
    </Box>
    :
    <ProfileCard applicant={applicant} isReferrerActive={isReferrerActive} navigateTo={handleReferralInfo} />
  );
};